module.exports = __webpack_public_path__ + "static/media/shape3.f36a936a.png";